import React, { useEffect, useState } from 'react';
import { Grid, IconButton } from '@material-ui/core';
import PhotoCamera from '@material-ui/icons/PhotoCamera';
import './style.css';
import { useTranslation } from 'react-i18next';
import { getFile } from '@opu/utils';

const ImageUploader = (props) => {
  const { t, i18n } = useTranslation();
  const { defaultValue, disabled, module, title = t('book.uploadImage') } = props;

  return (
    <Grid item container direction="row">
      <div className="image-wrapper cover-logo-wrapper">
        {defaultValue ? (
          defaultValue instanceof File ? (
            <img className="image-uploader" src={URL.createObjectURL(defaultValue)} alt="school logo" />
          ) : (
            <img className="image-uploader" src={getFile(module, defaultValue)} alt="school logo" />
          )
        ) : (
          <div className="uploader-div">
            <PhotoCamera style={{ fontSize: '3rem' }} />
            <h3>{title}</h3>
          </div>
        )}
        {!disabled && (
          <div className="overlay">
            <input style={{ display: 'none' }} id="cover" type="file" {...props} accept="image/png, image/jpg, image/jpeg" />
            <label htmlFor="cover">
              <IconButton aria-label="upload picture" component="span">
                <PhotoCamera style={{ fontSize: '3rem' }} />
              </IconButton>
            </label>
          </div>
        )}
      </div>
      <br />
    </Grid>
  );
};

export default ImageUploader;
